<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items" :style="{ 'background-image' : 'url(' + item.img + ')' }" >
			<!-- <pre>{{items}}</pre> -->
			<div class="row">
				<div class="cols s_24 l_12">
					<div class="wrapper">
						<p class="title" v-if="item.title" :style="`color: ${item.titleColor}`" v-html="item.title"></p>
						<p class="text" v-if="item.text" :style="`color: ${item.textColor}`" v-html="item.text"></p>

						<div :class="item.button2 || item.link2 ? 'buttonWr smallBtn' : 'buttonWr'">
							<a v-if="item.link" class="btn waves-effect waves-light" :href="item.link.href" :style="`color: ${item.textColor}`">{{item.link.textButton}}</a>

							<a v-else-if="item.button"
							   :style="`background-color: ${item.titleColor}`"
							   data-fancybox
							   :href='`#${item.button.popupFormID}`'
							   :data-key="item.button.key"
							   class="btn waves-effect waves-light">
								{{item.button.textButton}}
							</a>

							<a v-if="item.link2" class="btn waves-effect waves-light" :href="item.link2.href"
							>{{item.link2.textButton}}</a>

							<a v-else-if="item.button2"
							   :style="`background-color: ${item.titleColor}`"
							   data-fancybox
							   :href='`#${item.button2.popupFormID}`'
							   :data-key="item.button2.key"
							   class="btn waves-effect waves-light">
								{{item.button2.textButton}}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {
    }
	},

  methods: {
    sendId(formId) {
			console.log(formId);
			$(`#${formId}`).fancybox();
			// $('#id-form').fancybox();
    }
  },

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true,
				dots: true,
				autoplay: false,
                smartSpeed: 1000,
				// onDragged: setTimeout(function(){
				// 	let color = $('.mainSlider').find('p.title').eq(2).css('color');
				// 	$('.mainSlider .owl-dot').css('border-color', `${color}`);
				// 	console.log($('.mainSlider .owl-dot'));
				// 	$('.owl-carousel')
				// 	console.log(color);
				// }, 300)
			}
		});

		// console.log(this.items[0].titleColor);
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-mainSlider {
    height: 450px;
		overflow: hidden;
		position: relative;

		.owl-carousel {
			.item {
        height: 450px;
				display: flex;
				align-items: center;
				background-size: cover;
				background-position: center;
				.wrapper{
					padding: 0;
					text-align: center;
					@include m_up{
						padding: 0 55px;
						text-align: left;
					};
					@include l_up{
						padding: 0 0 0 rem(113);
					};
					.title{
						font-family: $ProximaNova_black;
						font-size: rem(28);
						line-height: rem(40);
						margin-bottom: rem(29);
						max-height: rem(120);
						overflow: hidden;
						@include m_up{
							font-size: rem(30);
						};
						@include l_up{
							font-size: rem(42);
							line-height: rem(56);
							max-height: rem(168);
						};
					}
					.text{
						color: #333333;
						line-height: rem(24);
						max-height: rem(120);
						margin-bottom: rem(44);
					}
					.btn{
						width: rem(260);
						height: rem(58);
						border-radius: rem(25);
						display: flex;
						align-items: center;
						justify-content: center;
						text-decoration: none;
						color: white;
						cursor: pointer;
						@include single-transition();
						margin: auto;
						@include m_up{
							margin: 0 0 14px 0;
						};
					}
					.buttonWr{
						&.smallBtn{
							display: flex;
							flex-direction: column;
							@include m_up{
								flex-direction: row;
							}
							.btn{
								width: 100%;
								margin-bottom: 20px;
								@include m_up{
									width: rem(220);
									margin-bottom: 0;
								}
								margin-right: 30px;
								&:last-child{
									margin-right: 0;
								}
							}
						}
					}
				}
			}
			.owl-nav{
				font-size: 0;
				div{
					width: 42px;
					height: 42px;
					border-radius: 100%;
					background-color: rgba(white, .7);
					@include single-transition();
					background-size: 25px;
					background-position: center;
					background-repeat: no-repeat;
					background-image: url('../img/arr.svg');
					z-index: 3;
					&:hover{
						background-color: white;
					}
				}
				.owl-prev{
					position: absolute;
					bottom: 30px;
					left: 10px;
					transform: rotate(90deg);
					@include m_up{
						top: calc(50% - 21px);
						left: 25px;
					};
					@media (min-width: 1281px){
						left: calc(50% - 645px);
					}
					// @include l___up{
					// 	left: calc(50% - 790px);
					// };
				}
				.owl-next{
					position: absolute;
					bottom: 30px;
					right: 10px;
					transform: rotate(-90deg);
					@include m_up{
						top: calc(50% - 21px);
						right: 25px;
					};
					@media (min-width: 1281px){
						right: calc(50% - 645px);
					}
					// @include l___up{
					// 	right: calc(50% - 790px);
					// };
				}
			}
			.owl-dots {
				position: absolute;
				bottom: 40px;
				width: 100%;
				text-align: center;
				z-index: 2;
				@include l_up{
					bottom: 51px;
				};

				.owl-dot {
					display: inline-block;
					width: 12px;
					height: 12px;
					border-radius: 100%;
					cursor: pointer;
					margin: 0 5px;
					border-width: 1px;
					border-style: solid;
					@include single-transition(all, 300ms, ease);
					position: relative;
					&:before{
						position: absolute;
						width: 6px;
						height: 6px;
						content: "";
						border-radius: 100%;
						left: calc(50% - 3px);
						top: calc(50% - 3px);
						opacity: 0;
						background-color: var(--bg-color);
					}
					&:hover, &.active {
						&:before{
							opacity: 1;
						}
						// background-color: #fff;
						@include single-transition(all, 300ms, ease);
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// mainSlider.vue?118bc016